export const formDataModel = {
  project_description: "",
  candidate_names: [],
  candidate_names_input_box: "",
  num_names: 1,
  industry: "",
  tlds: [".com", ".org", ".net", ".io", ".ai"],
  domain_name_candidates: [],
  domain_name_candidates_input_box: [],
  num_domain_names: 1,
  job_type: "name_ideation",
};
